import { FunctionComponent, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { Dropdown } from "primereact/dropdown";

import { translationKeys } from "../../../../models/app-translation-keys";
import { AppLanguageOptions } from "../../../../models/constants/app-language-options.const";
import { ILanguageOption } from "../../../../models/interfaces";
import { useStore } from "../../../../stores/StoreContext";

import "./LanguageSelection.scss";

export const LanguageSelection: FunctionComponent = () => {
  const { t } = useTranslation();
  const { userStore } = useStore();

  const languageSelectionRef = useRef<Dropdown>(null);

  const [selectedLanguage, setSelectedLanguage] = useState<ILanguageOption>();

  const handleLanguageSelectButtonChange = (languageOption: ILanguageOption) => {
    setSelectedLanguage(languageOption);
    userStore.changeLanguage(languageOption);
  };

  useEffect(() => {
    const foundLanguage: ILanguageOption | undefined = AppLanguageOptions.find(
      option => option.code === userStore.currentLanguage.code,
    );
    setSelectedLanguage(foundLanguage);
  }, [userStore.currentLanguage]);

  const dropdownItemTemplate = (item: ILanguageOption) => (
    <span>{t(translationKeys.language[item.code as keyof typeof translationKeys.language])}</span>
  );

  const dropdownValueTemplate = (item: ILanguageOption) => <span>{item.code?.toUpperCase()}</span>;

  return selectedLanguage ? (
    <Dropdown
      ref={languageSelectionRef}
      value={selectedLanguage}
      onChange={event => handleLanguageSelectButtonChange(event.value)}
      options={AppLanguageOptions}
      className="language-dropdown plain"
      name="language-dropdown"
      itemTemplate={dropdownItemTemplate}
      valueTemplate={dropdownValueTemplate}
    />
  ) : (
    <span>N/A</span>
  );
};
